import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import AddLinkIcon from '@mui/icons-material/AddLink';
import { Button, Stack } from '@mui/material';

import { FilterButton } from '@/components/buttons';
import { NomenclatureCreateActionButton, NomenclatureMainDuplicateButton } from '@/components/nomenclature';
import { DataGridToolbar } from '@/components/ReactDataGrid';
import { SearchInput } from '@/components/SearchInput';
import { searchHintNames } from '@/shared/constants/storage';

import {
  useIsFilterPanelVisible,
  useNomenclatureSearchQuery,
  useReconciliationBindingActions,
  useSelectedNomenclatureDrug,
  useSelectedUnboundDrug,
} from '../reconciliation-binding.store';

const Search = () => {
  const searchQuery = useNomenclatureSearchQuery();
  const { setNomenclatureSearchQuery, clearNomenclatureSearchQuery } = useReconciliationBindingActions();

  return (
    <SearchInput
      searchQuery={searchQuery}
      searchHintName={searchHintNames.reconciliationNomenclature}
      setSearchQuery={setNomenclatureSearchQuery}
      clearSearchQuery={clearNomenclatureSearchQuery}
      sx={{ width: '100%' }}
      instance="reconciliation-nomenclature"
    />
  );
};

export const ReconciliationNomenclatureToolbar = () => {
  const { t } = useTranslation('orders-page');
  const selectedNomenclatureDrug = useSelectedNomenclatureDrug();
  const selectedUnboundDrug = useSelectedUnboundDrug();
  const isFilterPanelVisible = useIsFilterPanelVisible();
  const { openBindDialog, toggleFilterPanel } = useReconciliationBindingActions();

  const isBindEnabled = Boolean(selectedNomenclatureDrug && selectedUnboundDrug);

  return (
    <DataGridToolbar actions={<FilterButton isActive={isFilterPanelVisible} onClick={toggleFilterPanel} />}>
      <Fragment>
        <Button
          variant="contained"
          color="secondary"
          disabled={!isBindEnabled}
          startIcon={<AddLinkIcon fontSize="small" />}
          onClick={openBindDialog}
          sx={{ px: 3 }}
        >
          {t('reconciliation.binding.actions.bind')}
        </Button>

        <Stack direction="row" spacing={0.5}>
          <NomenclatureCreateActionButton />
          <NomenclatureMainDuplicateButton disabled={!selectedNomenclatureDrug} />
        </Stack>

        <Search />
      </Fragment>
    </DataGridToolbar>
  );
};
